import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from 'library';
import { LocalStorageKey } from 'projects/store/src/app/enums';

export const sellerTraceabilityReportGuard: CanActivateFn = () => {
  const localStorageService = inject(LocalStorageService);
  const router = inject(Router);
  const data = localStorageService.get(LocalStorageKey.data);

  if (data?.distributor?.setting?.habilita_doble_vendedor === true) {
    return true;
  }

  return router.createUrlTree(['/inicio']);
};
